<template>
  <div>
    <v-row class="px-2 pt-8" style="background-color: #f2f2f2">
      <v-col cols="12" md="12">
        <v-btn><a class="smallcaps" href="/">Home</a></v-btn
        ><br />
        <v-btn outlined
          ><a class="smallcaps" href="/info/vertragscheck"
            >VertragsCheck</a
          ></v-btn
        >
        <br />

        <v-btn
          ><a class="smallcaps" href="/info/anspruchspruefung"
            >Anspruchsprüfung</a
          ></v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "menue-out-mobile",

  computed: {},
};
</script>

